import atob from './atob';
export default (function (input) {
  return atob(input.replace(/-/g, '+').replace(/_/g, '/'));
});